import React, { useEffect, useContext, useState } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import Axios from "axios"
import { useImmerReducer } from 'use-immer';
import { Grid, Snackbar, Typography, Button, TextField, FormControlLabel, Checkbox, Select, MenuItem, InputLabel, FormControl, Box, Paper, CircularProgress } from "@mui/material";
import { useTranslation } from 'react-i18next';

//
import StateContext from "../../Contexts/StateContext";

import { listingTypeOptions, propertyStatusOptions, rentalFrequencyOptions } from "../../Constants/IngatlanOptions";

function ListingUpdate() {
    const { t } = useTranslation();
    const { config, environment } = require('../../index');
    const navigate = useNavigate();
    const params = useParams();
    const GlobalState = useContext(StateContext);

    const [listingData, setListingData] = useState(null);
    const [loading, setLoading] = useState(true);

    const initialState = {
        titleValue: '',
        listingTypeValue: '',
        descriptionValue: '',
        areaValue: '',
        boroughValue: '',
        propertyStatusValue: '',
        priceStatusValue: '',
        priceValue: '',
        currencyValue: 'RON',
        rentFrequencyValue: '',
        roomsValue: '',
        furnishedValue: false,
        poolValue: false,
        elevatorValue: false,
        airconditioningValue: false,
        parkingValue: false,
        wellnessValue: false,
        kitchenValue: false,
        breakfastValue: false,
        petsAllowedValue: false,
        wifiValue: false,
        airportTransferValue: false,
        vacationTicketValue: false,
        // Car specific values
        brandValue: '',
        modelValue: '',
        yearValue: '',
        engineSizeValue: '',
        fuelValue: '',
        mileageValue: '',
        transmissionValue: '',
        conditionValue: '',
        powerValue: '',
        featuresValue: '',
        seatsValue: '',
        sendRequest: 0,
        openSnack: false,
        disabledListingUpdateBtn: false,
    };

    function ReducerFunction(draft, action) {
        switch (action.type) {
            case 'catchAll':
                draft.titleValue = action.listingObject.title || '';
                draft.listingTypeValue = action.listingObject.listing_type || '';
                draft.descriptionValue = action.listingObject.description || '';
                draft.areaValue = action.listingObject.area || '';
                draft.boroughValue = action.listingObject.borough || '';
                draft.propertyStatusValue = action.listingObject.property_status || '';
                draft.priceStatusValue = action.listingObject.price_status || '';
                draft.priceValue = action.listingObject.price || '';
                draft.currencyValue = action.listingObject.currency || 'RON';
                draft.rentFrequencyValue = action.listingObject.rent_frequency || '';
                draft.roomsValue = action.listingObject.rooms || '';
                draft.furnishedValue = action.listingObject.furnished || false;
                draft.poolValue = action.listingObject.pool || false;
                draft.elevatorValue = action.listingObject.elevator || false;
                draft.airconditioningValue = action.listingObject.airconditioning || false;
                draft.parkingValue = action.listingObject.parking || false;
                draft.wellnessValue = action.listingObject.wellness || false;
                draft.kitchenValue = action.listingObject.kitchen || false;
                draft.breakfastValue = action.listingObject.breakfast || false;
                draft.petsAllowedValue = action.listingObject.pets_allowed || false;
                draft.wifiValue = action.listingObject.wifi || false;
                draft.airportTransferValue = action.listingObject.airport_transfer || false;
                draft.vacationTicketValue = action.listingObject.vacation_ticket || false;
                
                draft.brandValue = action.listingObject.brand || '';
                draft.modelValue = action.listingObject.model || '';
                draft.yearValue = action.listingObject.year || '';
                draft.engineSizeValue = action.listingObject.engine_size_l || '';
                draft.fuelValue = action.listingObject.fuel || '';
                draft.mileageValue = action.listingObject.mileage || '';
                draft.transmissionValue = action.listingObject.transmission || '';
                draft.conditionValue = action.listingObject.condition || '';
                draft.powerValue = action.listingObject.power || '';
                draft.featuresValue = action.listingObject.features || '';
                draft.seatsValue = action.listingObject.seats || '';
                break;
            case 'catchTitleChange':
                draft.titleValue = action.titleChosen;
                break;
            case 'catchListingTypeChange':
                draft.listingTypeValue = action.listingTypeChosen;
                break;
            case 'catchDescriptionChange':
                draft.descriptionValue = action.descriptionChosen;
                break;
            case 'catchPropertyStatusChange':
                draft.propertyStatusValue = action.propertyStatusChosen;
                break;
            case 'catchPriceStatusChange':
                draft.priceStatusValue = action.priceStatusChosen;
                break;
            case 'catchPriceChange':
                draft.priceValue = action.priceChosen;
                break;
            case 'catchCurrencyChange':
                draft.currencyValue = action.currencyChosen;
                break;
            case 'catchBrandChange':
                draft.brandValue = action.brandChosen;
                break;
            case 'catchModelChange':
                draft.modelValue = action.modelChosen;
                break;
            case 'catchYearChange':
                draft.yearValue = action.yearChosen;
                break;
            case 'catchEngineSizeChange':
                draft.engineSizeValue = action.engineSizeChosen;
                break;
            case 'catchFuelChange':
                draft.fuelValue = action.fuelChosen;
                break;
            case 'catchMileageChange':
                draft.mileageValue = action.mileageChosen;
                break;
            case 'catchTransmissionChange':
                draft.transmissionValue = action.transmissionChosen;
                break;
            case 'catchConditionChange':
                draft.conditionValue = action.conditionChosen;
                break;
            case 'catchPowerChange':
                draft.powerValue = action.powerChosen;
                break;
            case 'catchFeaturesChange':
                draft.featuresValue = action.featuresChosen;
                break;
            case 'catchSeatsChange':
                draft.seatsValue = action.seatsChosen;
                break;
            case 'catchRentFrequencyChange':
                draft.rentFrequencyValue = action.rentFrequencyChosen;
                break;
            case 'catchRoomsChange':
                draft.roomsValue = action.roomsChosen;
                break;
            case 'catchFurnishedChange':
                draft.furnishedValue = action.furnishedChosen;
                break;
            case 'catchPoolChange':
                draft.poolValue = action.poolChosen;
                break;
            case 'catchElevatorChange':
                draft.elevatorValue = action.elevatorChosen;
                break;
            case 'catchAirconditioningChange':
                draft.airconditioningValue = action.airConditioningChosen;
                break;
            case 'catchParkingChange':
                draft.parkingValue = action.parkingChosen;
                break;
            case 'catchWellnessChange':
                draft.wellnessValue = action.wellnessChosen;
                break;
            case 'catchKitchenChange':
                draft.kitchenValue = action.kitchenChosen;
                break;
            case 'catchBreakfastChange':
                draft.breakfastValue = action.breakfastChosen;
                break;
            case 'catchPetsAllowedChange':
                draft.petsAllowedValue = action.petsAllowedChosen;
                break;
            case 'catchWifiChange':
                draft.wifiValue = action.wifiChosen;
                break;
            case 'catchAirportTransferChange':
                draft.airportTransferValue = action.airportTransferChosen;
                break;
            case 'catchVacationTicketChange':
                draft.vacationTicketValue = action.vacationTicketChosen;
                break;
            case 'changeSendRequest':
                draft.sendRequest = draft.sendRequest + 1;
                break;
            case 'openTheSnack':
                draft.openSnack = true;
                break;
            case 'disabledListingUpdateBtn':
                draft.disabledListingUpdateBtn = true;
                break;
            case 'allowTheListingUpdateBtn':
                draft.disabledListingUpdateBtn = false;
                break;
            default:
                break;
        }
    }

    const [state, dispatch] = useImmerReducer(ReducerFunction, initialState);

    useEffect(() => {
        async function getListingData() {
            try {
                const endpoint = params.type === 'car' ? config[environment].getCarInfoEndpoint(params.id) : config[environment].getPropertyInfoEndpoint(params.id);
                const response = await Axios.get(endpoint);
                setListingData(response.data);
                dispatch({ type: 'catchAll', listingObject: response.data });
                setLoading(false);
            } catch (e) {
                console.log(e.response);
            }
        }
        getListingData();
    }, [params.id, params.type, config, environment]);

    function FormSubmit(e) {
        e.preventDefault();
        dispatch({ type: 'changeSendRequest' });
        dispatch({ type: 'disabledListingUpdateBtn' })
    }

    useEffect(() => {
        if (state.sendRequest) {
            const data = new FormData();
            data.append('title', state.titleValue);
            if (params.type === 'car') {
                data.append('listing_type', 'Auto');
            } else {
                data.append('listing_type', state.listingTypeValue);
            }
            data.append('description', state.descriptionValue);
            data.append('property_status', state.propertyStatusValue);
            data.append('price_status', state.priceStatusValue);
            data.append('price', state.priceValue);
            data.append('currency', state.currencyValue);
            data.append('rent_frequency', state.rentFrequencyValue);

            // Car specific
            if (params.type === 'car') {
                data.append('brand', state.brandValue);
                data.append('model', state.modelValue);
                data.append('year', state.yearValue);
                data.append('engine_size_l', state.engineSizeValue);
                data.append('fuel', state.fuelValue);
                data.append('mileage', state.mileageValue);
                data.append('transmission', state.transmissionValue);
                data.append('condition', state.conditionValue);
                data.append('power', state.powerValue);
                data.append('features', state.featuresValue);
                data.append('seats', state.seatsValue);
            }
            data.append('rooms', state.roomsValue);
            data.append('furnished', state.furnishedValue);
            data.append('pool', state.poolValue);
            data.append('elevator', state.elevatorValue);
            data.append('airconditioning', state.airconditioningValue);
            data.append('parking', state.parkingValue);
            data.append('wellness', state.wellnessValue);
            data.append('kitchen', state.kitchenValue);
            data.append('breakfast', state.breakfastValue);
            data.append('pets_allowed', state.petsAllowedValue);
            data.append('wifi', state.wifiValue);
            data.append('airport_transfer', state.airportTransferValue);
            data.append('vacation_ticket', state.vacationTicketValue);
            data.append('latitude', listingData.latitude);
            data.append('longitude', listingData.longitude);
            data.append('seller', GlobalState.userId);
            
            if (params.type === 'car') {
                 data.append('key', 'Auto');
            } else {
                 data.append('key', 'Property');
            }

            async function UpdateProperty() {
                try {
                    const endpoint = params.type === 'car' ? config[environment].getCarUpdateEndpoint(params.id) : config[environment].getPropertyUpdateEndpoint(params.id);
                    const token = GlobalState.jwtAccessToken || localStorage.getItem('jwtAccessToken');
                    const response = await Axios.patch(endpoint, data, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'Authorization': `Bearer ${token}`
                        }
                    });
                    dispatch({ type: 'openTheSnack' });
                } catch (e) {
                    dispatch({
                        type: 'allowTheListingUpdateBtn',
                    })
                }
            }
            UpdateProperty();
        }
    }, [config, environment, state.sendRequest]);

    useEffect(() => {
        let timeoutId;
        if (state.openSnack) {
            timeoutId = setTimeout(() => {
                navigate(`/${params.type}/${params.id}`);
            }, 1500);
        }
        return () => {
            clearTimeout(timeoutId);
        };
    }, [state.openSnack, navigate, params.type, params.id]);

    if (loading) {
        return (
            <Grid container justifyContent="center" alignItems="center" style={{ height: '80vh' }}>
                <CircularProgress />
            </Grid>
        );
    }

    return (
        <Box sx={{ mt: '50px', p: 3 }}>
            <Paper elevation={3} sx={{ p: 4, maxWidth: '800px', mx: 'auto' }}>
                <form onSubmit={FormSubmit}>
                    <Typography variant='h4' gutterBottom align="center" sx={{ color: '#105b79', fontWeight: 'bold' }}>
                        {t('Market.UpdateObject', 'OBJEKTUM FRISSÍTÉSE')}
                    </Typography>

                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <TextField id="title" label={t('Common.Title', 'Title*')} variant="outlined" fullWidth value={state.titleValue}
                                onChange={(e) => dispatch({ type: 'catchTitleChange', titleChosen: e.target.value })} />
                        </Grid>

                        <Grid item xs={12}>
                            <TextField id="description" label={t('Common.Description', 'Description')} variant="outlined" fullWidth multiline rows={4} value={state.descriptionValue}
                                onChange={(e) => dispatch({ type: 'catchDescriptionChange', descriptionChosen: e.target.value })} />
                        </Grid>

                        {params.type !== 'car' && (
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth variant="outlined">
                                    <InputLabel id="listing-type-label">{t('Market.ListingType', 'Listing Type*')}</InputLabel>
                                    <Select
                                        labelId="listing-type-label"
                                        id="listing_type"
                                        value={state.listingTypeValue}
                                        label={t('Market.ListingType', 'Listing Type*')}
                                        onChange={(e) => dispatch({ type: 'catchListingTypeChange', listingTypeChosen: e.target.value })}
                                    >
                                        {listingTypeOptions.map((option) => (
                                            <MenuItem key={option.value} value={option.value}>
                                                {t(option.label, option.label)}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                        )}

                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth variant="outlined">
                                <InputLabel id="property-status-label">{t('Market.PropertyStatus', 'Property Status*')}</InputLabel>
                                <Select
                                    labelId="property-status-label"
                                    id="property_status"
                                    value={state.propertyStatusValue}
                                    label={t('Market.PropertyStatus', 'Property Status*')}
                                    onChange={(e) => dispatch({ type: 'catchPropertyStatusChange', propertyStatusChosen: e.target.value })}
                                >
                                    {propertyStatusOptions.map((option) => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {t(option.label, option.label)}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={4}>
                            <TextField id="price" label={t('Common.Price', 'Price*')} variant="outlined" fullWidth type="number" value={state.priceValue}
                                onChange={(e) => dispatch({ type: 'catchPriceChange', priceChosen: e.target.value })} />
                        </Grid>

                        <Grid item xs={12} sm={4}>
                            <FormControl fullWidth variant="outlined">
                                <InputLabel id="currency-label">{t('Common.Currency', 'Currency')}</InputLabel>
                                <Select
                                    labelId="currency-label"
                                    id="currency"
                                    value={state.currencyValue}
                                    label={t('Common.Currency', 'Currency')}
                                    onChange={(e) => dispatch({ type: 'catchCurrencyChange', currencyChosen: e.target.value })}
                                >
                                    <MenuItem value="RON">RON</MenuItem>
                                    <MenuItem value="HUF">HUF</MenuItem>
                                    <MenuItem value="EUR">EUR</MenuItem>
                                    <MenuItem value="USD">USD</MenuItem>
                                    <MenuItem value="GBP">GBP</MenuItem>
                                    <MenuItem value="CHF">CHF</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>

                        {state.propertyStatusValue === 'Kiadó' && (
                            <Grid item xs={12} sm={4}>
                                <FormControl fullWidth variant="outlined">
                                    <InputLabel id="rent-frequency-label">{t('Market.RentalFrequency', 'Rental Frequency')}</InputLabel>
                                    <Select
                                        labelId="rent-frequency-label"
                                        id="rent_frequency"
                                        value={state.rentFrequencyValue}
                                        label={t('Market.RentalFrequency', 'Rental Frequency')}
                                        onChange={(e) => dispatch({ type: 'catchRentFrequencyChange', rentFrequencyChosen: e.target.value })}
                                    >
                                        {rentalFrequencyOptions.map((option) => (
                                            <MenuItem key={option.value} value={option.value}>
                                                {t(option.label, option.label)}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                        )}

                        {params.type === 'car' && (
                            <>
                                <Grid item xs={12} sm={6}>
                                    <TextField label={t('Car.Brand', 'Márka')} variant="outlined" fullWidth value={state.brandValue}
                                        onChange={(e) => dispatch({ type: 'catchBrandChange', brandChosen: e.target.value })} />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField label={t('Car.Model', 'Modell')} variant="outlined" fullWidth value={state.modelValue}
                                        onChange={(e) => dispatch({ type: 'catchModelChange', modelChosen: e.target.value })} />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <TextField label={t('Car.Year', 'Évjárat')} variant="outlined" fullWidth type="number" value={state.yearValue}
                                        onChange={(e) => dispatch({ type: 'catchYearChange', yearChosen: e.target.value })} />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <TextField label={t('Car.EngineSize', 'Hengerűrtartalom (l)')} variant="outlined" fullWidth type="number" inputProps={{ step: 0.1 }} value={state.engineSizeValue}
                                        onChange={(e) => dispatch({ type: 'catchEngineSizeChange', engineSizeChosen: e.target.value })} />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <TextField label={t('Car.Power', 'Teljesítmény (LE)')} variant="outlined" fullWidth type="number" value={state.powerValue}
                                        onChange={(e) => dispatch({ type: 'catchPowerChange', powerChosen: e.target.value })} />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField label={t('Car.Mileage', 'Kilométeróra állása (km)')} variant="outlined" fullWidth type="number" value={state.mileageValue}
                                        onChange={(e) => dispatch({ type: 'catchMileageChange', mileageChosen: e.target.value })} />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField label={t('Car.Transmission', 'Sebességváltó')} variant="outlined" fullWidth value={state.transmissionValue}
                                        onChange={(e) => dispatch({ type: 'catchTransmissionChange', transmissionChosen: e.target.value })} />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField label={t('Car.Fuel', 'Üzemanyag')} variant="outlined" fullWidth value={state.fuelValue}
                                        onChange={(e) => dispatch({ type: 'catchFuelChange', fuelChosen: e.target.value })} />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField label={t('Car.Seats', 'Ülések száma')} variant="outlined" fullWidth type="number" value={state.seatsValue}
                                        onChange={(e) => dispatch({ type: 'catchSeatsChange', seatsChosen: e.target.value })} />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField label={t('Car.Features', 'Felszereltség')} variant="outlined" fullWidth multiline rows={2} value={state.featuresValue}
                                        onChange={(e) => dispatch({ type: 'catchFeaturesChange', featuresChosen: e.target.value })} />
                                </Grid>
                            </>
                        )}

                        {params.type !== 'car' && (
                             <Grid item xs={12} sm={4}>
                                <TextField label={t('Market.Rooms', 'Rooms')} variant="outlined" fullWidth type="number" value={state.roomsValue}
                                    onChange={(e) => dispatch({ type: 'catchRoomsChange', roomsChosen: e.target.value })} />
                            </Grid>
                        )}

                        <Grid item xs={12}>
                            <Typography variant="h6" sx={{ mt: 2, mb: 1, color: '#105b79' }}>{t('Market.Amenities', 'Extras')}</Typography>
                            <Grid container>
                                {params.type !== 'car' ? (
                                    <>
                                        <Grid item xs={6} sm={4}><FormControlLabel control={<Checkbox checked={state.furnishedValue} onChange={(e) => dispatch({ type: 'catchFurnishedChange', furnishedChosen: e.target.checked })} />} label={t('Market.Furnished', 'Furnished')} /></Grid>
                                        <Grid item xs={6} sm={4}><FormControlLabel control={<Checkbox checked={state.poolValue} onChange={(e) => dispatch({ type: 'catchPoolChange', poolChosen: e.target.checked })} />} label={t('Market.Pool', 'Pool')} /></Grid>
                                        <Grid item xs={6} sm={4}><FormControlLabel control={<Checkbox checked={state.elevatorValue} onChange={(e) => dispatch({ type: 'catchElevatorChange', elevatorChosen: e.target.checked })} />} label={t('Market.Elevator', 'Elevator')} /></Grid>
                                        <Grid item xs={6} sm={4}><FormControlLabel control={<Checkbox checked={state.airconditioningValue} onChange={(e) => dispatch({ type: 'catchAirconditioningChange', airConditioningChosen: e.target.checked })} />} label={t('Market.AirConditioning', 'Air Conditioning')} /></Grid>
                                        <Grid item xs={6} sm={4}><FormControlLabel control={<Checkbox checked={state.parkingValue} onChange={(e) => dispatch({ type: 'catchParkingChange', parkingChosen: e.target.checked })} />} label={t('Market.Parking', 'Parking')} /></Grid>
                                        <Grid item xs={6} sm={4}><FormControlLabel control={<Checkbox checked={state.wifiValue} onChange={(e) => dispatch({ type: 'catchWifiChange', wifiChosen: e.target.checked })} />} label={t('Market.Wifi', 'Wifi')} /></Grid>
                                    </>
                                ) : (
                                    <Grid item xs={6} sm={4}><FormControlLabel control={<Checkbox checked={state.airconditioningValue} onChange={(e) => dispatch({ type: 'catchAirconditioningChange', airConditioningChosen: e.target.checked })} />} label={t('Car.AirConditioning', 'Klíma')} /></Grid>
                                )}
                            </Grid>
                        </Grid>

                        <Grid item xs={12} sx={{ mt: 3 }}>
                            <Button variant='contained' fullWidth type='submit' disabled={state.disabledListingUpdateBtn} sx={{ backgroundColor: '#105b79', '&:hover': { backgroundColor: '#0d4a63' }, py: 1.5, fontSize: '1.1rem' }}>
                                {t('Common.Update', 'FRISSÍT')}
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </Paper>

            <Snackbar
                open={state.openSnack}
                message={t('Market.ListingUpdatedSuccessfully', 'Listing updated successfully!')}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            />
        </Box>
    );
}

export default ListingUpdate;
